import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Shield, Award } from "lucide-react";

const OMW_LOGO = "https://customer-assets.emergentagent.com/job_54aeb419-6630-419e-b73e-06cd0626cb80/artifacts/7mqqpftb_original-logos_2019_Oct_8089-5dab77750dc93.jpeg";

const Footer = () => {
  return (
    <footer className="bg-[#1E3A5F] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-6">
            <img 
              src={OMW_LOGO} 
              alt="OMW Business" 
              className="h-16 w-auto bg-white rounded-lg p-2"
            />
            <p className="text-gray-300 text-sm leading-relaxed">
              Helping small businesses find innovative solutions for startup, growth, and expansion since 2019.
            </p>
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2 text-xs bg-white/10 px-3 py-2 rounded-full">
                <Shield className="h-4 w-4 text-[#9D9045]" />
                <span>Veteran Owned</span>
              </div>
              <div className="flex items-center gap-2 text-xs bg-white/10 px-3 py-2 rounded-full">
                <Award className="h-4 w-4 text-[#9D9045]" />
                <span>NNA Certified</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>Quick Links</h4>
            <ul className="space-y-3">
              {[
                { name: "About Us", path: "/about" },
                { name: "Services", path: "/services" },
                { name: "Business School", path: "/school" },
                { name: "Blog", path: "/blog" },
                { name: "Contact", path: "/contact" },
              ].map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-gray-300 hover:text-[#9D9045] transition-colors text-sm">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-lg mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>Our Services</h4>
            <ul className="space-y-3">
              {[
                { name: "Business Strategy & Coaching", path: "/services" },
                { name: "Business Startup", path: "/services" },
                { name: "Money Management", path: "/services" },
                { name: "Business Formation", path: "https://www.corpnet.com/?PID=12459/", external: true },
                { name: "Logo & Product Design", path: "/services" },
                { name: "Mobile Notary Services", path: "/notary" },
              ].map((service) => (
                <li key={service.name}>
                  {service.external ? (
                    <a href={service.path} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white text-sm">
                      {service.name}
                    </a>
                  ) : (
                    <Link to={service.path} className="text-gray-300 hover:text-white text-sm">
                      {service.name}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-lg mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="h-5 w-5 text-[#9D9045] flex-shrink-0 mt-0.5" />
                <div>
                  <a href="tel:+18772955905" className="text-gray-300 hover:text-white text-sm">
                    (877) 295-5905
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="h-5 w-5 text-[#9D9045] flex-shrink-0 mt-0.5" />
                <div>
                  <a href="mailto:omwbusiness@consultant.com" className="text-gray-300 hover:text-white text-sm break-all">
                    omwbusiness@consultant.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-[#9D9045] flex-shrink-0 mt-0.5" />
                <div className="text-gray-300 text-sm">
                  4049 US Highway 231 #1003<br />
                  Wetumpka, Alabama
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="h-5 w-5 text-[#9D9045] flex-shrink-0 mt-0.5" />
                <div className="text-gray-300 text-sm">
                  Mon-Fri: 9AM - 5PM<br />
                  Sat: 11AM - 2PM
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} OMW Business & Financial Resources. All rights reserved.
          </p>
          <p className="text-gray-400 text-sm">
            Service Disabled Veteran Owned Small Business
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
